import { useMemo } from 'react';
import { useGetStaticQuery } from 'store/reducers/api/static';

const transformEnum = (enumData?: Record<string, string>) => {
  if (!enumData) return {};
  return Object.entries(enumData).reduce((acc, [key, value]) => {
    acc[value.toUpperCase().replace(/ /g, '_')] = Number(key);
    return acc;
  }, {} as Record<string, number>);
};

const useEnums = () => {
  const { data: statics } = useGetStaticQuery();

  return useMemo(() => {
    return {
      UserRolesEnum: transformEnum(statics?.user_roles),
      SensorStatusesEnum: transformEnum(statics?.sensor_statuses),
      WaterVolumeTypesEnum: transformEnum(statics?.water_volume_types),
      SensorStatesEnum: transformEnum(statics?.sensor_states),
      GatewayStatusesEnum: transformEnum(statics?.gateway_statuses),
      ApplianceTypesEnum: transformEnum(statics?.appliances_types),
      PropertyTypesEnum: transformEnum(statics?.property_types),
      BuildingTypesEnum: transformEnum(statics?.building_types),
      BuildingInstallationTypesEnum: transformEnum(statics?.building_installation_types),
      UnitTypesEnum: transformEnum(statics?.unit_types),
      UnitStatesEnum: transformEnum(statics?.unit_states),
      WaterTypesEnum: transformEnum(statics?.water_types),
      RoomsEnum: transformEnum(statics?.room_types),
      NotificationCategoriesEnum: transformEnum(statics?.notification_categories),
      NotificationStatusesEnum: transformEnum(statics?.notification_statuses),
      NotificationMethodsEnum: transformEnum(statics?.notification_methods),
      NotificationTypesEnum: transformEnum(statics?.notification_types),
      UserStatusesEnum: transformEnum(statics?.user_statuses),
      UnitCategoriesEnum: transformEnum(statics?.unit_categories),
      reportTypesEnum: transformEnum(statics?.report_types),
      SystemEventCodesEnum: statics?.system_event_codes,
      SystemEventSubCodes: statics?.system_event_sub_codes
    };
  }, [statics]);
};

export default useEnums;
